"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fabSizeL = exports.fabSizeM = exports.fabSizeS = exports.highContrast = exports.defaultVariant = exports.alternative = exports.navigationHC = exports.navigation = void 0;
/* ⚠️⚠️⚠️ DANGER ZONE ⚠️⚠️⚠️ DANGER ZONE ⚠️⚠️⚠️ DANGER ZONE ⚠️⚠️⚠️
 * Changing shared code can have unintended consequences for all brands.
 * Please double check with the team before making changes here.
 * If brand specific changes are needed, they should be made in the brand's theme file.
 */
var material_1 = require("@mui/material");
var floatingButtonsCommon = {
    width: '3rem',
    minWidth: '3rem',
    height: '3rem',
    minHeight: '3rem',
    borderRadius: '1.5rem',
    boxShadow: 'none',
    aspectRatio: '1 / 1',
};
exports.navigation = {
    props: { variant: 'navigation' },
    style: function (_a) {
        var _b;
        var theme = _a.theme;
        return (__assign(__assign({}, floatingButtonsCommon), (_b = { backgroundColor: 'transparent', color: "var(--secondary-500, ".concat(theme.palette.secondary.main, ")"), '&:hover': {
                    backgroundColor: (0, material_1.alpha)(theme.palette.neutrals.disabled, 0.2),
                    color: "var(--text-interactive, ".concat(theme.palette.text.interactive, ")"),
                }, '&:focus': {
                    backgroundColor: (0, material_1.alpha)(theme.palette.neutrals.disabled, 0.2),
                    color: "var(--text-interactive, ".concat(theme.palette.text.interactive, ")"),
                }, '&:active': {
                    backgroundColor: (0, material_1.alpha)(theme.palette.neutrals.disabled, 0.6),
                    color: "var(--text-interactive, ".concat(theme.palette.text.interactive, ")"),
                } }, _b["&.".concat(material_1.fabClasses.disabled)] = {
            color: "var(--text-disabled, ".concat(theme.palette.text.disabled, ")"),
            backgroundColor: 'transparent',
        }, _b)));
    },
};
exports.navigationHC = {
    props: { variant: 'navigationHC' },
    style: function (_a) {
        var _b;
        var theme = _a.theme;
        return (__assign(__assign({}, floatingButtonsCommon), (_b = { backgroundColor: 'transparent', color: "var(--text-light, ".concat(theme.palette.text.light, ")"), '&:hover': {
                    backgroundColor: "var(--secondary-300, ".concat(theme.palette.secondary.light, ")"),
                    color: "var(--secondary-500, ".concat(theme.palette.secondary.main, ")"),
                }, '&:focus': {
                    backgroundColor: "var(--secondary-300, ".concat(theme.palette.secondary.light, ")"),
                    color: "var(--secondary-500, ".concat(theme.palette.secondary.main, ")"),
                }, '&:active': {
                    backgroundColor: "var(--neutrals-300, ".concat(theme.palette.neutrals.primary, ")"),
                    color: "var(--secondary-500, ".concat(theme.palette.secondary.main, ")"),
                } }, _b["&.".concat(material_1.fabClasses.disabled)] = {
            color: "var(--text-disabled, ".concat(theme.palette.text.disabled, ")"),
            backgroundColor: 'transparent',
        }, _b)));
    },
};
exports.alternative = {
    props: { variant: 'alternative' },
    style: function (_a) {
        var _b;
        var theme = _a.theme;
        return (__assign(__assign({}, floatingButtonsCommon), (_b = { backgroundColor: "var(--primary-500, ".concat(theme.palette.text.primary, ")"), color: "var(--text-light, ".concat(theme.palette.text.light, ")"), '&:hover': {
                    backgroundColor: "var(--primary-700, ".concat(theme.palette.primary.dark, ")"),
                    color: "var(--text-light, ".concat(theme.palette.text.light, ")"),
                }, '&:focus': {
                    backgroundColor: "var(--primary-700, ".concat(theme.palette.primary.dark, ")"),
                    color: "var(--text-light, ".concat(theme.palette.text.light, ")"),
                }, '&:active': {
                    backgroundColor: "var(--secondary-300, ".concat(theme.palette.secondary.light, ")"),
                    color: "var(--text-primary, ".concat(theme.palette.text.primary, ")"),
                } }, _b["&.".concat(material_1.fabClasses.disabled)] = {
            color: "var(--text-disabled, ".concat(theme.palette.text.disabled, ")"),
            backgroundColor: "var(--neutrals-100, ".concat(theme.palette.backgrounds.neutral, ")"),
        }, _b)));
    },
};
exports.defaultVariant = {
    props: { variant: 'default' },
    style: function (_a) {
        var _b;
        var theme = _a.theme;
        return (__assign(__assign({}, floatingButtonsCommon), (_b = { backgroundColor: "var(--secondary-500, ".concat(theme.palette.text.interactive, ")"), color: "var(--text-light, ".concat(theme.palette.text.light, ")"), '&:hover': {
                    backgroundColor: "var(--secondary-700, ".concat(theme.palette.text.interactive, ")"),
                    color: "var(--text-light, ".concat(theme.palette.text.light, ")"),
                }, '&:focus': {
                    backgroundColor: "var(--secondary-700, ".concat(theme.palette.text.interactive, ")"),
                    color: "var(--text-light, ".concat(theme.palette.text.light, ")"),
                }, '&:active': {
                    backgroundColor: "var(--secondary-300, ".concat(theme.palette.secondary.light, ")"),
                    color: "var(--primary-500, ".concat(theme.palette.text.primary, ")"),
                } }, _b["&.".concat(material_1.fabClasses.disabled)] = {
            color: "var(--text-disabled, ".concat(theme.palette.text.disabled, ")"),
            backgroundColor: "var(--neutrals-100, ".concat(theme.palette.backgrounds.neutral, ")"),
        }, _b)));
    },
};
exports.highContrast = {
    props: { variant: 'highContrast' },
    style: function (_a) {
        var _b;
        var theme = _a.theme;
        return (__assign(__assign({}, floatingButtonsCommon), (_b = { backgroundColor: 'transparent', color: "var(--primary-500, ".concat(theme.palette.text.interactive, ")"), '&:hover': {
                    backgroundColor: "var(--secondary-300, ".concat(theme.palette.backgrounds.light, ")"),
                    color: "var(--primary-500, ".concat(theme.palette.text.interactive, ")"),
                }, '&:focus': {
                    backgroundColor: "var(--secondary-300, ".concat(theme.palette.backgrounds.light, ")"),
                    color: "var(--primary-500, ".concat(theme.palette.text.interactive, ")"),
                }, '&:active': {
                    backgroundColor: "var(--secondary-300, ".concat(theme.palette.secondary.light, ")"),
                    color: "var(--primary-500, ".concat(theme.palette.text.primary, ")"),
                } }, _b["&.".concat(material_1.fabClasses.disabled)] = {
            color: "var(--text-disabled, ".concat(theme.palette.text.disabled, ")"),
            backgroundColor: "var(--neutrals-100, ".concat(theme.palette.backgrounds.neutral, ")"),
        }, _b)));
    },
};
exports.fabSizeS = {
    props: { size: 'S' },
    style: {
        width: '2.5rem',
        minWidth: '2.5rem',
        height: '2.5rem',
        minHeight: '2.5rem',
    },
};
exports.fabSizeM = {
    props: { size: 'M' },
    style: {
        width: '3rem',
        minWidth: '3rem',
        height: '3rem',
        minHeight: '3rem',
    },
};
exports.fabSizeL = {
    props: { size: 'L' },
    style: {
        width: '3.5rem',
        minWidth: '3.5rem',
        height: '3.5rem',
        minHeight: '3.5rem',
    },
};
